import api, { handleResponse, handleError } from './api';

/** Contacts sync: hashes in, the accounts they belong to out. Nothing stored. */
const contactService = {
  /** `hashes`: lowercase hex SHA-256 of E.164 numbers → `{ checked, matches: [{ userId, displayName, handle, avatarUrl, hash, relationshipStatus }] }`. */
  async match(hashes) {
    try {
      return handleResponse(await api.post('/contacts/match', { hashes }));
    } catch (error) {
      return handleError(error);
    }
  },
};

export default contactService;
